import type { DocumentLineInput, LineTotals } from './types';

/**
 * Calcule les totaux d'une ligne de document.
 * Logique pure, sans dépendance externe.
 *
 * Formule :
 *   totalHtBeforeDiscount = qty * unitPriceHt
 *   discountAmount = totalHtBeforeDiscount * discountPct / 100
 *   totalHt = totalHtBeforeDiscount - discountAmount
 *   vatAmount = totalHt * vatRate / 100
 *   totalTtc = totalHt + vatAmount
 *
 * Arrondi : 3 décimales (millimes tunisiens)
 */
export function calculateLineTotals(line: DocumentLineInput): LineTotals {
  const totalHtBeforeDiscount = round3(line.quantity * line.unitPriceHt);
  const discountAmount = round3(totalHtBeforeDiscount * line.discountPct / 100);
  const totalHt = round3(totalHtBeforeDiscount - discountAmount);
  const vatAmount = round3(totalHt * line.vatRate / 100);
  const totalTtc = round3(totalHt + vatAmount);

  return {
    totalHtBeforeDiscount,
    discountAmount,
    totalHt,
    totalTtc,
    vatAmount,
  };
}

function round3(n: number): number {
  return Math.round(n * 1000) / 1000;
}
